import React from 'react';

import ContentConnectorApollo from '../../Content/Connector/Apollo/ContentConnectorApollo';
import UserNameEmailConnectorApollo from '../Connector/Apollo/Fetch/UserNameEmailConnectorApollo';
import SendEmailConnectorApollo from '../Connector/Apollo/SendEmailConnectorApollo';
import ContactContainer from './ContactContainer';

class ContactPage extends React.Component {
    static propTypes = {};

    render() {
        return (
            <ContentConnectorApollo identifier="faq:dietitian">
                {({ ...contentData }) => (
                    <UserNameEmailConnectorApollo>
                        {({ ...userData }) => (
                            <SendEmailConnectorApollo>
                                {({ contactEmail }) => {
                                    return (
                                        <ContactContainer
                                            content={contentData.content}
                                            userData={userData.userData}
                                            loading={
                                                contentData.loading ||
                                                userData.loading
                                            }
                                            contactEmail={contactEmail}
                                        />
                                    );
                                }}
                            </SendEmailConnectorApollo>
                        )}
                    </UserNameEmailConnectorApollo>
                )}
            </ContentConnectorApollo>
        );
    }
}

export default ContactPage;
